export class QuizQuestion {
  ID: number;
  Question: string;
  Explanation: string;
  Rank: string;
  MediaClipId: number;
}
